// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  skillId: __t.string().primaryKey().name("skill_id"),
  displayName: __t.string().name("display_name"),
  description: __t.string(),
  cooldownTicks: __t.i64().name("cooldown_ticks"),
  staminaCost: __t.i32().name("stamina_cost"),
  durationTicks: __t.i64().name("duration_ticks"),
  castTimeTicks: __t.i64().name("cast_time_ticks"),
  range: __t.i32(),
  damage: __t.i32(),
  radius: __t.i32(),
  emoji: __t.string(),
  inputsJson: __t.string().name("inputs_json"),
  tags: __t.array(__t.string()),
  metaChildrenJson: __t.string().name("meta_children_json"),
});
